module.exports = __webpack_public_path__ + "img/img_data_power_retail@3x.3b2b19b7.png";